export default {

    GET_RECOMMENDED_PRESCRIPTION_REQUEST: 'GET_RECOMMENDED_PRESCRIPTION_REQUEST',
    GET_RECOMMENDED_PRESCRIPTION_SUCCESS: 'GET_RECOMMENDED_PRESCRIPTION_SUCCESS',
    GET_RECOMMENDED_PRESCRIPTION_FAILURE: 'GET_RECOMMENDED_PRESCRIPTION_FAILURE',

    CREATE_PRESCRIPTION_REQUEST: 'CREATE_PRESCRIPTION_REQUEST',
    CREATE_PRESCRIPTION_SUCCESS: 'CREATE_PRESCRIPTION_SUCCESS',
    CREATE_PRESCRIPTION_FAILURE: 'CREATE_PRESCRIPTION_FAILURE',

    GET_PATIENT_PRESCRIPTION_REQUEST: 'GET_PATIENT_PRESCRIPTION_REQUEST',
    GET_PATIENT_PRESCRIPTION_SUCCESS: 'GET_PATIENT_PRESCRIPTION_SUCCESS',
    GET_PATIENT_PRESCRIPTION_FAILURE: 'GET_PATIENT_PRESCRIPTION_FAILURE',

  };
  